"use strict";
export var TransactionStepType = /* @__PURE__ */ ((TransactionStepType2) => {
  TransactionStepType2["TokenApprovalTransaction"] = "TokenApproval";
  TransactionStepType2["TokenRevocationTransaction"] = "TokenRevocation";
  TransactionStepType2["SwapTransaction"] = "SwapTransaction";
  TransactionStepType2["SwapTransactionAsync"] = "SwapTransactionAsync";
  TransactionStepType2["SwapTransactionBatched"] = "SwapTransactionBatched";
  TransactionStepType2["WrapTransaction"] = "WrapTransaction";
  TransactionStepType2["Permit2Signature"] = "Permit2Signature";
  TransactionStepType2["Permit2Transaction"] = "Permit2Transaction";
  TransactionStepType2["UniswapXSignature"] = "UniswapXSignature";
  TransactionStepType2["IncreasePositionTransaction"] = "IncreasePositionTransaction";
  TransactionStepType2["IncreasePositionTransactionAsync"] = "IncreasePositionTransactionAsync";
  TransactionStepType2["IncreasePositionTransactionBatched"] = "IncreasePositionTransactionBatched";
  TransactionStepType2["DecreasePositionTransaction"] = "DecreasePositionTransaction";
  TransactionStepType2["DecreasePositionTransactionBatched"] = "DecreasePositionTransactionBatched";
  TransactionStepType2["MigratePositionTransaction"] = "MigratePositionTransaction";
  TransactionStepType2["MigratePositionTransactionAsync"] = "MigratePositionTransactionAsync";
  TransactionStepType2["CollectFeesTransactionStep"] = "CollectFeesTransaction";
  TransactionStepType2["CollectLpIncentiveRewardsTransactionStep"] = "CollectLpIncentiveRewardsTransactionStep";
  return TransactionStepType2;
})(TransactionStepType || {});
